import Vue from 'vue'
import CustomRange from './quiz/CustomRange.vue'
import LoadingProgress from './quiz/LoadingProgress.vue'
import ReviewsList from './ReviewsList.vue'
import SubscriptionForms from "./SubscriptionForms.vue";
import Logo from "./Logo.vue";
import LoginModal from "./modals/Login.vue";
import RegisterModal from "./modals/Register.vue";
import PasswordResetModal from "./modals/PasswordReset.vue";
import FAQ from "./FAQ.vue";
import ExpandPanel from "./ExpandPanel.vue";
import QuizCalculator from "./quiz/quiz-calculator.vue";
import QuizScale from "./quiz/quiz-scale.vue";
import QuizUsers from "./quiz/quiz-users.vue";
import QuizTips from "./quiz/quiz-tips.vue";
import QuizPressure from "./quiz/quiz-pressure.vue";
import QuizHeightCalculator from "./quiz/quiz-height-calculator.vue";

Vue.component('range', CustomRange)
Vue.component('loading-progress', LoadingProgress)
Vue.component('reviews-list', ReviewsList)
Vue.component('subscription-forms', SubscriptionForms)
Vue.component('logo', Logo)
Vue.component('login-modal', LoginModal)
Vue.component('register-modal', RegisterModal)
Vue.component('password-reset-modal', PasswordResetModal)
Vue.component('landing-faq', FAQ)
Vue.component('landing-expand-panel', ExpandPanel)
Vue.component('quiz-calculator', QuizCalculator)
Vue.component('quiz-height-calculator', QuizHeightCalculator)
Vue.component('quiz-scale', QuizScale)
Vue.component('quiz-users', QuizUsers)
Vue.component('quiz-tips', QuizTips)
Vue.component('quiz-pressure', QuizPressure)
